// @ts-nocheck
import axios from '../utils/axios';
import { ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT } from '../config';
import { catchAsync } from '../utils/api';

const getAppVersion = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/versions/management-tool`);

    return result.data;
});

const AppVersionService = {
    getAppVersion,
};

export default AppVersionService;
